/**
 * Tabs Vuex Module
 * 管理多开页面的标签页状态
 */
export default {
  namespaced: true,
  state: {
    // 已打开的标签页列表
    tabs: [],
    // 当前活跃的标签页 key
    activeTabKey: ''
  },
  mutations: {
    ADD_TAB(state, tab) {
      const existing = state.tabs.find(t => t.key === tab.key)
      if (!existing) {
        tab.componentName = tab.componentName || ''
        state.tabs.push(tab)
      }
    },
    REMOVE_TAB(state, key) {
      state.tabs = state.tabs.filter(t => t.key !== key)
    },
    SET_ACTIVE_TAB(state, key) {
      state.activeTabKey = key
    },
    CLOSE_OTHER_TABS(state, key) {
      state.tabs = state.tabs.filter(t => t.key === key || t.key === '/home/dashboard')
      state.activeTabKey = key
    },
    CLOSE_ALL_TABS(state) {
      state.tabs = state.tabs.filter(t => t.key === '/home/dashboard')
      state.activeTabKey = '/home/dashboard'
    }
  },
  actions: {
    /**
     * 打开或切换到某个标签页
     */
    openTab({ commit }, route) {
      const key = route.route.fullPath
      const title = route.route.meta?.menu || route.route.meta?.breadcrumb || route.route.name || '未命名'
      commit('ADD_TAB', {
        key,
        title,
        path: route.route.path,
        query: route.route.query || {},
        name: route.route.name,
        componentName: route.componentName || ''
      })
      commit('SET_ACTIVE_TAB', key)
    },

    /**
     * 关闭标签页，返回需要导航的目标路径（如有）
     */
    closeTab({ commit, state }, { key, $router }) {
      const index = state.tabs.findIndex(t => t.key === key)
      if (index === -1) return
      const isActive = state.activeTabKey === key

      commit('REMOVE_TAB', key)

      if (isActive && state.tabs.length > 0) {
        const targetIndex = Math.min(index, state.tabs.length - 1)
        const target = state.tabs[targetIndex]
        commit('SET_ACTIVE_TAB', target.key)
        $router.push({ path: target.path, query: target.query })
      }
    },

    /**
     * 关闭其他标签页
     */
    closeOtherTabs({ commit, state }, { key, $router }) {
      const tab = state.tabs.find(t => t.key === key)
      if (!tab) return
      commit('CLOSE_OTHER_TABS', key)
      $router.push({ path: tab.path, query: tab.query })
    },

    /**
     * 关闭所有标签页（保留首页）
     */
    closeAllTabs({ commit, state }) {
      commit('CLOSE_ALL_TABS')
      const dashboard = state.tabs.find(t => t.key === '/home/dashboard')
      if (dashboard) {
        // 需要外部传入 router 实例
      }
    }
  },
  getters: {
    tabs: state => state.tabs,
    activeTabKey: state => state.activeTabKey,
    tabCount: state => state.tabs.length
  }
}
